import React, { useState, useImperativeHandle } from 'react';
import Slider from '@material-ui/core/Slider';
import { SelectArrow, TickMarkCircle, TickMarkBlankCircle } from './Icons';
import { dateFormatter } from './functions/dateFunctions';
import { dateRange } from './functions/dateFunctions';

const RangeFilterDate = (props) => {

  const {
          filterTitle,
          filterName,
          filterOpen,
          handleFilter,
          dateBounds,
          setIndexValue,
          dateFilterActive,
          setDateFilterActive,
          dateRangeRef,
          dateIndexValue,
          today
        } = props;

  const handleChange = (event, newValue) => {
    setIndexValue(newValue);
  };
  const valuetext = (value) => dateBounds[value];
  const handleFilterEntry = () => setDateFilterActive(!dateFilterActive);




  const [dateIndexValueGhost, setDateIndexValueGhost] = useState([0, dateRange('1990-04-01', today).length-1]);

  const handleTemporaryDateChange = (event, newValue) => {
    setDateIndexValueGhost(newValue);
  };

  const resetIndexValueGhost = () => {
    setDateIndexValueGhost([0, dateRange('1990-04-01', today).length-1]);
  };



  const allSelected = () => {
    const maxRange = dateRange('1990-04-01', today).length-1;
    const rangeOfValues = dateIndexValue[1] - dateIndexValue[0];

    if (rangeOfValues === maxRange && !dateFilterActive) {
      return true;
    } else {
      return false;
    }

  }

  allSelected()

  useImperativeHandle(dateRangeRef, () => {
    return {
      resetIndexValueGhost: resetIndexValueGhost
    };
  });




  return (
    <div className={`${(filterOpen===filterName) ? 'expanded' : 'closed' } filter-tab `}>
      <div className='filter-expander' id={ filterName } onClick={(e) => handleFilter(e)}>
        <div>
          <h2 className='color-invert'>{ filterTitle }</h2>

          <p className='color-invert'>
            {
              (allSelected()) ? 'All Selected' : (
                (!dateFilterActive) ? 'Multiple Selections' : dateFormatter(dateBounds[dateIndexValueGhost[0]]) + ' - ' + dateFormatter(dateBounds[dateIndexValueGhost[1]-1]) )
            }
          </p>

        </div>
        <SelectArrow className={(filterOpen===filterName) ?  'arrow' : 'arrow-spin-90' }/>
      </div>


      <div className='range-container-wrapper'>
        <div className='range-values'>
          <p className='color-invert'>{dateFormatter(dateBounds[dateIndexValueGhost[0]])}</p>
          <p className='color-invert'>{dateFormatter(dateBounds[dateIndexValueGhost[1]-1])}</p>
        </div>

        <div className='range-container'>
          <Slider
            min={ 0 }
            max={ dateBounds.length-1 }
            value={ dateIndexValueGhost }
            onChangeCommitted={ handleChange }
            onChange={ handleTemporaryDateChange }
            aria-labelledby="range-slider"
            getAriaValueText={ valuetext }
          />
        </div>

        <div className='filter-select-all flex-container-left' onClick={() => handleFilterEntry()}>
          { !dateFilterActive && <TickMarkCircle className='inline-style'/> }
          { dateFilterActive && <TickMarkBlankCircle className='inline-style'/> }

          <p className='color-invert inline-style'>Inc. Projects not at Planning</p>
        </div>
      </div>
    </div>
  )
}

export default RangeFilterDate;
